"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToken = exports.useTokens = void 0;
const sail_1 = require("@saberhq/sail");
const token_utils_1 = require("@saberhq/token-utils");
const use_solana_1 = require("@saberhq/use-solana");
const web3_js_1 = require("@solana/web3.js");
const lodash_zip_1 = __importDefault(require("lodash.zip"));
const react_1 = require("react");
const sdk_1 = require("./sdk");
/**
 * Uses and loads a series of mints.
 * @param mints
 * @returns
 */
const useTokens = (mints) => {
    const { network } = (0, use_solana_1.useSolana)();
    const chainId = (0, token_utils_1.networkToChainId)(network);
    const { tokenMap } = (0, sdk_1.useQuarrySDK)();
    const normalizedMints = (0, react_1.useMemo)(() => {
        var _a;
        return (_a = mints === null || mints === void 0 ? void 0 : mints.map((mint) => ((mint === null || mint === void 0 ? void 0 : mint.equals(web3_js_1.PublicKey.default)) ? null : mint))) !== null && _a !== void 0 ? _a : [];
    }, [mints]);
    const mintAccounts = (0, sail_1.useParsedAccountsData)(normalizedMints, sail_1.MINT_PARSER);
    return (0, react_1.useMemo)(() => {
        const tokensFromMap = normalizedMints === null || normalizedMints === void 0 ? void 0 : normalizedMints.map((mintKey) => mintKey ? tokenMap === null || tokenMap === void 0 ? void 0 : tokenMap.get(mintKey.toString()) : null);
        return (0, lodash_zip_1.default)(tokensFromMap, mintAccounts, normalizedMints).map(([tokenFromMap, mintAccount, mintKey]) => {
            var _a;
            const decimals = (_a = mintAccount === null || mintAccount === void 0 ? void 0 : mintAccount.accountInfo.data) === null || _a === void 0 ? void 0 : _a.decimals;
            return (tokenFromMap !== null && tokenFromMap !== void 0 ? tokenFromMap : (mintAccount && decimals !== undefined && chainId && mintKey
                ? token_utils_1.Token.fromMint(mintKey, decimals, {
                    chainId,
                    symbol: mintKey.toString().slice(0, 5),
                })
                : mintAccount === undefined
                    ? undefined
                    : null));
        });
    }, [normalizedMints, mintAccounts, tokenMap, chainId]);
};
exports.useTokens = useTokens;
/**
 * Uses and loads one token.
 * @param mint
 * @returns
 */
const useToken = (mint) => {
    const tokenMints = (0, react_1.useMemo)(() => [mint], [mint]);
    const [token] = (0, exports.useTokens)(tokenMints);
    return token;
};
exports.useToken = useToken;
//# sourceMappingURL=useToken.js.map